export const REGISTER_CONTEST_REQUEST = 'REGISTER_CONTEST_REQUEST';
export const REGISTER_CONTEST_SUCCESS = 'REGISTER_CONTEST_SUCCESS';
export const REGISTER_CONTEST_FAILURE = 'REGISTER_CONTEST_FAILURE'; 
//fetch my participant with contest id
export const FETCH_PARTICIPANT_BY_ID_REQUEST = 'FETCH_PARTICIPANT_BY_ID_REQUEST';
export const FETCH_PARTICIPANT_BY_ID_SUCCESS = 'FETCH_PARTICIPANT_BY_ID_SUCCESS';
export const FETCH_PARTICIPANT_BY_ID_FAILURE = 'FETCH_PARTICIPANT_BY_ID_FAILURE';
//fetch participants of a contest
export const FETCH_PARTICIPANTS_BY_ID_REQUEST = 'FETCH_PARTICIPANTS_BY_ID_REQUEST';
export const FETCH_PARTICIPANTS_BY_ID_SUCCESS = 'FETCH_PARTICIPANTS_BY_ID_SUCCESS';
export const FETCH_PARTICIPANTS_BY_ID_FAILURE = 'FETCH_PARTICIPANTS_BY_ID_FAILURE';
//cancel registration
export const CANCEL_REGISTRATION_REQUEST = 'CANCEL_REGISTRATION_REQUEST';
export const CANCEL_REGISTRATION_SUCCESS = 'CANCEL_REGISTRATION_SUCCESS';
export const CANCEL_REGISTRATION_FAILURE = 'CANCEL_REGISTRATION_FAILURE'; 